import { Action } from '@ngrx/store';
import { ProblemForUserModel } from './model';

export enum ActionTypes {
  FAILURE = '[ProblemForUser] Failure',

  LOAD_REQUEST = '[ProblemForUser] Load Request',
  LOAD_SUCCESS = '[ProblemForUser] Load Success',

  CREATE_SUBSCRIPTION_REQUEST = '[ProblemForUser] Create Subscription Request',
  CREATE_SUBSCRIPTION_SUCCESS = '[ProblemForUser] Create Subscription Success',

  DELETE_SUBSCRIPTION_REQUEST = '[ProblemForUser] Delete Subscription Request',
  DELETE_SUBSCRIPTION_SUCCESS = '[ProblemForUser] Delete Subscription Success',

  CREATE_LOCK_REQUEST = '[ProblemForUser] Create Lock Request',
  CREATE_LOCK_SUCCESS = '[ProblemForUser] Create Lock Success',
}

export class FailureAction implements Action {
  readonly type = ActionTypes.FAILURE;
  constructor(public error: string) {}
}

export class LoadRequestAction implements Action {
  readonly type = ActionTypes.LOAD_REQUEST;
  constructor(public userId: number) {}
}

export class LoadSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_SUCCESS;
  constructor(public items: ProblemForUserModel[]) {}
}

export class CreateSubscriptionRequestAction implements Action {
  readonly type = ActionTypes.CREATE_SUBSCRIPTION_REQUEST;
  constructor(
    public problemId: number,
    public userId: number
  ) {}
}

export class CreateSubscriptiondSuccessAction implements Action {
  readonly type = ActionTypes.CREATE_SUBSCRIPTION_SUCCESS;
  constructor(public problem: ProblemForUserModel) {}
}

export class DeleteSubscriptionRequestAction implements Action {
  readonly type = ActionTypes.DELETE_SUBSCRIPTION_REQUEST;
  constructor(public subscriptionId: number) {}
}

export class DeleteSubscriptiondSuccessAction implements Action {
  readonly type = ActionTypes.DELETE_SUBSCRIPTION_SUCCESS;
  constructor(public problem: ProblemForUserModel) {}
}

export class CreateLockRequestAction implements Action {
  readonly type = ActionTypes.CREATE_LOCK_REQUEST;
  constructor(
    public problemId: number,
    public userId: number
  ) {}
}

export class CreateLockSuccessAction implements Action {
  readonly type = ActionTypes.CREATE_LOCK_SUCCESS;
  constructor(public problem: ProblemForUserModel) {}
}

export type Actions =
  | FailureAction
  | LoadRequestAction
  | LoadSuccessAction
  | CreateSubscriptionRequestAction
  | CreateSubscriptiondSuccessAction
  | DeleteSubscriptionRequestAction
  | DeleteSubscriptiondSuccessAction
  | CreateLockRequestAction
  | CreateLockSuccessAction;
